import { Application } from "@hotwired/stimulus"

// Import controllers explicitly for esbuild
import AutosaveController from "./autosave_controller"
import FlashMessagesController from "./flash_messages_controller"
import FormController from "./form_controller"
import FormValidationController from "./form_validation_controller"
import IdeaEvaluationController from "./idea_evaluation_controller"
import ContributorAssignmentController from "./contributor_assignment_controller"
import IngredientFormController from "./ingredient_form_controller"
import SearchController from "./search_controller"
import SortableController from "./sortable_controller"
import ContributorSortableController from "./contributor_sortable_controller"
import TagifyController from "./tagify_controller"
import TagsController from "./tags_controller"
import CommentController from "./comment_controller"
import RecipePreviewController from "./recipe_preview_controller"
import TrixToolbarController from "./trix_toolbar_controller"
import DeleteConfirmController from "./delete_confirm_controller"
import DirectUploadController from "./direct_upload_controller"
import WorkOrderPreviewController from "./work_order_preview_controller"
import RecipeRepublishController from "./recipe_republish_controller"
import ContentGapAnalysisController from "./content_gap_analysis_controller"
import GenerateIdeasController from "./generate_ideas_controller"
import HubSectionSelectController from "./hub_section_select_controller"
import IdeasCalendarController from "./ideas_calendar_controller"
import IdeasPlanController from "./ideas_plan_controller"
import IdeasSheetController from "./ideas_sheet_controller"

window.Stimulus = Application.start()

// Register controllers explicitly
Stimulus.register("autosave", AutosaveController)
Stimulus.register("flash-messages", FlashMessagesController)
Stimulus.register("form", FormController)
Stimulus.register("form-validation", FormValidationController)
Stimulus.register("idea-evaluation", IdeaEvaluationController)
Stimulus.register("contributor-assignment", ContributorAssignmentController)
Stimulus.register("ingredient-form", IngredientFormController)
Stimulus.register("search", SearchController)
Stimulus.register("sortable", SortableController)
Stimulus.register("contributor-sortable", ContributorSortableController)
Stimulus.register("tagify", TagifyController)
Stimulus.register("tags", TagsController)
Stimulus.register("comment", CommentController)
Stimulus.register("delete-confirm", DeleteConfirmController)
Stimulus.register("recipe-preview", RecipePreviewController)
Stimulus.register("trix-toolbar", TrixToolbarController)
Stimulus.register("direct-upload", DirectUploadController)
Stimulus.register("work-order-preview", WorkOrderPreviewController)
Stimulus.register("recipe-republish", RecipeRepublishController)
Stimulus.register("content-gap-analysis", ContentGapAnalysisController)
Stimulus.register("generate-ideas", GenerateIdeasController)
Stimulus.register("hub-section-select", HubSectionSelectController)
Stimulus.register("ideas-calendar", IdeasCalendarController)
Stimulus.register("ideas-plan", IdeasPlanController)
Stimulus.register("ideas-sheet", IdeasSheetController)